import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { placeholderImage } from '../../car-reviews-v2'

export const removeDuplicatesKeepPlaceholders = (images: StoryblokImage[]) => {
  const seenIds = new Set()

  return images.reduce((uniqueImages: StoryblokImage[], image) => {
    const isPlaceholder = image.filename === placeholderImage.filename

    if (isPlaceholder || !image.id || !seenIds.has(image.id)) {
      if (image.id) seenIds.add(image.id)
      uniqueImages.push(image)
    }

    return uniqueImages
  }, [])
}
